import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationModalComponent } from 'dirty-check-store';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LcaService } from 'src/app/services/lca.service';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { environment } from 'src/environments/environment';
import { PostLcaComponent } from '../post-lca/post-lca.component';
import { WithdrawLcaComponent } from '../withdraw-lca/withdraw-lca.component';

@Component({
    selector: 'app-lca-details-view-mode',
    templateUrl: './lca-details-view-mode.component.html',
    styleUrls: ['./lca-details-view-mode.component.scss']
})
export class LcaDetailsViewModeComponent implements OnInit {
    lcaDetails: any;
    destroy$ = new Subject();

    originUrl: string;
    DisplayString: any;
    assignmentList = [];
    listUploadedFiles = [];
    envPath: any;
    constructor(
        private lcaService: LcaService,
        private router: Router,
        private route: ActivatedRoute,
        private petitionerService: PetitionerService,
        private toastService: ToastrService,
        public dialog: MatDialog,
    ) {
        const navState = this.router.getCurrentNavigation();

        this.originUrl = (navState.extras && navState.extras.state && navState.extras.state.redirectUrl) ? navState.extras.state.redirectUrl : '';
        this.originUrl = this.originUrl == '' ? '../lca' : this.originUrl; //fall back to list page 
        if (sessionStorage.getItem('originPage') && sessionStorage.getItem('originUrl')) {
            this.originUrl = sessionStorage.getItem('originUrl');
        }

        this.DisplayString =  new Map([
            ['HOUR', 'Hour'],
            ['WEEK', 'Week'],
            ['BIWEEKLY', 'Bi-Weekly'],
            ['MONTH', 'Month'],
            ['YEAR', 'Year'],
            ['WAGELVL1', 'I'],
            ['WAGELVL2', 'II'],
            ['WAGELVL3', 'III'],
            ['WAGELVL4', 'IV'],
            ['NOTAPPLCBL','N/A']
        ]);
    }

    ngOnInit(): void {
        this.envPath = environment.docs;
        if (sessionStorage.getItem("lcaId") !== null) {
            this.lcaService.getEFileDetails(parseInt(sessionStorage.getItem("lcaId"))).pipe(takeUntil(this.destroy$)).subscribe((response) => {
                if (response) {
                    this.lcaDetails = response;
                }
            });
        }

        this.petitionerService.getLcaDetailsById(parseInt(sessionStorage.getItem('lcaId'))).subscribe(data => {
            this.assignmentList = data['assignmentList'];
            this.listUploadedFiles = data['documents'];
        })
  
    }

    backToOriginPage() {
        if (this.originUrl?.includes('immigration-wizard')) {
            this.router.navigate([`${this.originUrl}`]);
        } else {
            this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
        }
    }

    getDisplayString(code) {
        return this.DisplayString.get(code);
    }


    handleDelete(lcaId) {
        const title = 'Confirm';
        const message = 'Do you wish to delete this LCA?';
        this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
            if (result) {
                this.petitionerService.deleteLca(lcaId).subscribe(data => {
                    this.toastService.success("Deleted successfully!");
                    this.backToOriginPage();
                });
            }
        });
    }

    dialogueInitializer(title: string, message: string) {
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '200px',
            data: {
                update: { title, message },
                buttons: ['Cancel', 'Delete']
            }
        });
        return dialogRef;
    }
    duplicateLCA(lca, isDuplicate) {
        sessionStorage.setItem("lcaId", lca.id);
        sessionStorage.setItem("isCertifiesId", lca.status.code);
        sessionStorage.setItem("isDuplicateLCA", isDuplicate ? 'true' : 'false');
        this.router.navigate(['../add-new'], { relativeTo: this.route, state: { redirectUrl: '../lca', redirectPage: 'Back to Lca List' } });
    }

    openPostLcaModal(lcaData) {
        this.dialog.open(PostLcaComponent, {
            width: '680px',
            data: lcaData
        }).afterClosed().subscribe(response => {
            if (response == true) {
                this.backToOriginPage();
            }
        });
    }
    openWithdrawLcaModal(lcaData) {
        this.dialog.open(WithdrawLcaComponent, {
            width: '800px',
            data: lcaData
        }).afterClosed().subscribe(response => {
            if (response == true) {
                this.backToOriginPage();
            }
        });
    }
}
